import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';

import {tariffAPI} from 'entities/tariff';
import {userAPI, userSelector} from 'entities/user';

export const useTariffsScreen = () => {
    const user = useSelector(userSelector);
    const location = useLocation();

    const {data, isLoading} = tariffAPI.useGetTariffsQuery({field: 'price', direction: 'asc'});
    const [resetHighlightTariff] = userAPI.useResetUserHighlightTariffMutation();

    useEffect(() => {
        const isTariffsPage = location.pathname.startsWith('/tariffs');

        if (user?.id && user?.highlight_tariff && isTariffsPage) {
            resetHighlightTariff(user.id);
        }
    }, [user, location.pathname, resetHighlightTariff]);

    return {items: data ?? [], isLoading};
};

export default useTariffsScreen;
